module.exports = __webpack_public_path__ + "img/icon-arrow-bottom.31d93490.svg";